import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLElement
  Blocks: {
    default: unknown[]
  }
}

export const TilesReporting: TOC<Signature> = <template>
  <section
    class="border-dusty-black-100 shadow-dusty-black-100 rounded-md border bg-white text-black shadow-md hover:text-black"
    ...attributes
  >
    {{yield}}
  </section>
</template>

export default TilesReporting
